import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss'
})
export class SearchBarComponent {

  constructor(public router: Router,
    public route: ActivatedRoute) {
  }

  @Input()
  searchText: string = '';

  @Input()
  selected: string = "1";

  @Output()
  search: EventEmitter<{ selected: string, text: string }> = new EventEmitter();

  onSearch() {
    this.search.emit({ selected: this.selected, text: this.searchText });
    this.route.snapshot.queryParamMap.get(this.searchText);
  }
  //onsearch on empty
  onSearchWithempty() {
    if (this.searchText.length == 0) {
      this.onSearch();
    }
  }
}
